// extracted by mini-css-extract-plugin
export default {"division":"AdminCustomerGroupCustomerCell_division__fsnK2","number":"AdminCustomerGroupCustomerCell_number__q-81b"};